import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useBeforeunload } from "react-beforeunload";
import { v4 as uuidv4 } from "uuid";
import { useApolloClient } from "@apollo/client";
import { SignupForm } from "@/components/Form/index";
import Steps from "@/components/Steps";
import routes from "@/lib/routes";
import { useAccountSignupPinCodeMutation, useAccountVerifyPinCodeMutation, useAccountSignupMutation, useClearRecommendArticleMutation, useStep } from "@/hooks";
import processStyles from "@/styles/Process.module.scss";
import SignUpMetaTags from "@/components/MetaTags/SignUpMetaTags";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function signUp() {
  var _useState = useState(false),
      verified = _useState[0],
      setVerify = _useState[1];

  var _useState2 = useState(false),
      submited = _useState2[0],
      setSubmited = _useState2[1];

  useBeforeunload(function (e) {
    if (!submited) {
      e.preventDefault();
    }
  });
  var router = useRouter();
  var client = useApolloClient();

  var _useStep = useStep(),
      step = _useStep.step,
      state = _useStep.state,
      dispatch = _useStep.dispatch;

  var _useAccountSignupPinC = useAccountSignupPinCodeMutation(),
      _useAccountSignupPinC2 = _slicedToArray(_useAccountSignupPinC, 2),
      pinCode = _useAccountSignupPinC2[0],
      _useAccountSignupPinC3 = _useAccountSignupPinC2[1],
      sendPinCodeLoading = _useAccountSignupPinC3.loading,
      sendPinCodeError = _useAccountSignupPinC3.error;

  var handleStep1 = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;

                          if (sendPinCodeLoading) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 4;
                          return pinCode({
                            variables: {
                              mailAddress: data.mailAddress
                            }
                          });

                        case 4:
                          dispatch({
                            type: "next",
                            formData: data
                          });

                        case 5:
                          resolve();
                          _context.next = 12;
                          break;

                        case 8:
                          _context.prev = 8;
                          _context.t0 = _context["catch"](0);
                          console.log(_context.t0);
                          reject();

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 8]]);
                }));

                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [sendPinCodeLoading]);

  var _useAccountVerifyPinC = useAccountVerifyPinCodeMutation(),
      _useAccountVerifyPinC2 = _slicedToArray(_useAccountVerifyPinC, 2),
      verify = _useAccountVerifyPinC2[0],
      pinCodeVerifyError = _useAccountVerifyPinC2[1].error;

  var handleStep2 = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return verify({
                            variables: {
                              code: data.code,
                              mailAddress: state.formData.mailAddress
                            }
                          });

                        case 3:
                          setVerify(true);
                          dispatch({
                            type: "next",
                            formData: _objectSpread({}, data)
                          });
                          resolve();
                          _context3.next = 12;
                          break;

                        case 8:
                          _context3.prev = 8;
                          _context3.t0 = _context3["catch"](0);
                          console.log(_context3.t0);
                          reject();

                        case 12:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0, 8]]);
                }));

                return function (_x5, _x6) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }(), [state.nextStep]);

  var _useAccountSignupMuta = useAccountSignupMutation(),
      _useAccountSignupMuta2 = _slicedToArray(_useAccountSignupMuta, 2),
      signup = _useAccountSignupMuta2[0],
      signupError = _useAccountSignupMuta2[1].error;

  var _useClearRecommendArt = useClearRecommendArticleMutation(),
      _useClearRecommendArt2 = _slicedToArray(_useClearRecommendArt, 1),
      clearRecommendArticle = _useClearRecommendArt2[0];

  var handleStep3 = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data, recommend) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve, reject) {
                  var terms, signupParams;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;

                          terms = function () {
                            var values = [];

                            if (data.terms) {
                              values.push(data.termsValue);
                            }

                            if (data.termsAd) {
                              values.push(data.termsAdValue);
                            }

                            if (data.termsMail) {
                              values.push(data.termsMailValue);
                            }

                            if (values.length > 0) {
                              return values.join(",");
                            } else {
                              return null;
                            }
                          }();

                          signupParams = _objectSpread(_objectSpread(_objectSpread({}, state.formData), data), {}, {
                            terms: terms,
                            signature: uuidv4()
                          });

                          if (submited) {
                            _context5.next = 12;
                            break;
                          }

                          setSubmited(true);
                          _context5.next = 7;
                          return signup({
                            variables: signupParams
                          });

                        case 7:
                          _context5.next = 9;
                          return fetch("/api/optional_terms", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                              confirm: true
                            })
                          });

                        case 9:
                          _context5.next = 11;
                          return clearRecommendArticle();

                        case 11:
                          client.resetStore().then(function () {
                            if (recommend && recommend.type === "svod") {
                              window.location.href = routes.svodPayment(recommend.id[0]);
                            } else if (recommend && recommend.type === "tvod") {
                              window.location.href = routes.tvodPayment(recommend.id[0]);
                            } else {
                              window.location.href = routes.signupComplete;
                            }

                            resolve();
                          });

                        case 12:
                          _context5.next = 19;
                          break;

                        case 14:
                          _context5.prev = 14;
                          _context5.t0 = _context5["catch"](0);
                          setSubmited(false);
                          console.log(_context5.t0);
                          reject();

                        case 19:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[0, 14]]);
                }));

                return function (_x9, _x10) {
                  return _ref6.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }(), [submited, state.nextStep]);
  useEffect(function () {
    if (step != state.nextStep) {
      var nextStep = function () {
        if (state.nextStep === 3 && !verified) {
          return 2;
        } else {
          return state.nextStep;
        }
      }();

      router.push(routes.signupStep(nextStep), undefined, {
        shallow: true,
        scroll: true
      });
    }
  }, [step, state.nextStep, verified]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SignUpMetaTags, {
      step: "step".concat(step)
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.inner,
        children: [/*#__PURE__*/_jsx("h2", {
          className: processStyles.heading,
          children: "\u65B0\u898F\u4F1A\u54E1\u767B\u9332"
        }), /*#__PURE__*/_jsx(Steps, {
          step: step,
          steps: ["メールアドレスの入力", "メールアドレスの認証", "会員情報の入力"]
        }), /*#__PURE__*/_jsxs("div", {
          children: [step === 1 && /*#__PURE__*/_jsx(SignupForm.Step1, {
            onSubmit: handleStep1,
            error: sendPinCodeError
          }), step === 2 && /*#__PURE__*/_jsx(SignupForm.Step2, {
            onSubmit: handleStep2,
            error: pinCodeVerifyError,
            formData: state.formData
          }), step === 3 && /*#__PURE__*/_jsx(SignupForm.Step3, {
            onSubmit: handleStep3,
            error: signupError,
            formData: state.formData,
            submited: submited
          })]
        })]
      })
    })]
  });
}
signUp.layout = "NoHeaderLayout";